var map = {
	"./Anyswap.png": 623,
	"./Anyswap.svg": 624,
	"./Artwork.svg": 625,
	"./Artwork_gmx.svg": 626,
	"./Banxa.png": 627,
	"./DROP_DOWN.svg": 365,
	"./Hop.png": 628,
	"./Hop.svg": 629,
	"./Hop_dark.png": 630,
	"./Hop_dark.svg": 631,
	"./Octagon_Check.svg": 366,
	"./Synapse.png": 632,
	"./Synapse.svg": 633,
	"./arbitrum.png": 367,
	"./bg_buy_oap.svg": 368,
	"./bg_buy_open.svg": 369,
	"./binance.png": 634,
	"./bscscan.png": 635,
	"./btn_big_arbitrum.png": 636,
	"./btn_big_avalanche.png": 637,
	"./btn_big_bsc.png": 638,
	"./btn_big_purchasegmx.png": 639,
	"./btn_big_purchasegmx.svg": 640,
	"./buy_gmx.svg": 370,
	"./buy_gmx_bond.svg": 641,
	"./buy_transfer_eth.svg": 642,
	"./coinbaseWallet.png": 371,
	"./coingecko.png": 643,
	"./cross.svg": 644,
	"./flag_en.svg": 645,
	"./flag_es.svg": 646,
	"./flag_fr.svg": 647,
	"./flag_ja.svg": 648,
	"./flag_ko.svg": 649,
	"./flag_ru.svg": 650,
	"./flag_zh.svg": 651,
	"./glp_icon.svg": 652,
	"./gmx-logo-final-white-small.png": 653,
	"./gmx-logo-final-white.png": 654,
	"./gmx-logo-final.png": 655,
	"./gmx-logo-glow.png": 656,
	"./gmx-logo-with-name.svg": 372,
	"./gmx_logo.svg": 657,
	"./graphite-01.png": 658,
	"./harmony.jpeg": 373,
	"./ic-communityproject.svg": 659,
	"./ic_arb_40.svg": 660,
	"./ic_arbitrum_16.svg": 192,
	"./ic_arbitrum_24.svg": 441,
	"./ic_arbitrum_96.svg": 215,
	"./ic_arbitrum_hover_16.svg": 661,
	"./ic_arrowleft16.svg": 662,
	"./ic_arrowright16.svg": 663,
	"./ic_avalanche_16.svg": 167,
	"./ic_avalanche_24.svg": 301,
	"./ic_avalanche_96.svg": 216,
	"./ic_avax_24.svg": 664,
	"./ic_avax_30.svg": 374,
	"./ic_avax_40.svg": 665,
	"./ic_banxa.svg": 302,
	"./ic_binance_logo.svg": 168,
	"./ic_bnb_24.svg": 666,
	"./ic_bnb_40.svg": 667,
	"./ic_bsc.svg": 668,
	"./ic_bsc_96.svg": 669,
	"./ic_bsc_circle.svg": 230,
	"./ic_btc.b_24.svg": 670,
	"./ic_btc.b_40.svg": 671,
	"./ic_btc_24.svg": 672,
	"./ic_btc_40.svg": 673,
	"./ic_busd_24.svg": 674,
	"./ic_busd_40.svg": 675,
	"./ic_buy_glp.svg": 676,
	"./ic_cash.png": 677,
	"./ic_cash.svg": 678,
	"./ic_checked.svg": 375,
	"./ic_coin.svg": 251,
	"./ic_coingecko_16.svg": 376,
	"./ic_coingecko_hover_16.svg": 679,
	"./ic_convert_down.svg": 442,
	"./ic_copy_16.svg": 443,
	"./ic_cost.svg": 377,
	"./ic_dai_24.svg": 680,
	"./ic_dai_40.svg": 681,
	"./ic_discord.svg": 378,
	"./ic_eth_24.svg": 682,
	"./ic_eth_40.svg": 683,
	"./ic_frax_24.svg": 684,
	"./ic_frax_40.svg": 685,
	"./ic_github.svg": 379,
	"./ic_glp_24.svg": 686,
	"./ic_glp_40.svg": 444,
	"./ic_glp_custom.svg": 687,
	"./ic_gmx.svg": 688,
	"./ic_gmx_24.svg": 303,
	"./ic_gmx_30.svg": 689,
	"./ic_gmx_40.svg": 690,
	"./ic_gmx_64.svg": 691,
	"./ic_gmx_arbitrum.svg": 380,
	"./ic_gmx_avax.svg": 381,
	"./ic_gmx_big.svg": 692,
	"./ic_gmx_custom.svg": 693,
	"./ic_gmx_footer.svg": 694,
	"./ic_harmony_one.svg": 382,
	"./ic_hop.svg": 383,
	"./ic_info.svg": 695,
	"./ic_language24.svg": 384,
	"./ic_link_24.svg": 696,
	"./ic_link_40.svg": 697,
	"./ic_liquidity.svg": 385,
	"./ic_medium.svg": 445,
	"./ic_menu_dots.svg": 698,
	"./ic_metamask_16.svg": 386,
	"./ic_metamask_hover_16.svg": 699,
	"./ic_mim_24.svg": 700,
	"./ic_mim_40.svg": 701,
	"./ic_multiswap.svg": 304,
	"./ic_new_link_16.svg": 446,
	"./ic_olympus.svg": 702,
	"./ic_olympus_arbitrum.svg": 387,
	"./ic_pig.svg": 388,
	"./ic_selector_dropdowns.svg": 703,
	"./ic_settings_16.svg": 704,
	"./ic_settings_24.svg": 705,
	"./ic_sign in_16.svg": 706,
	"./ic_sign_out_16.svg": 447,
	"./ic_simpleswaps.svg": 389,
	"./ic_stats.svg": 390,
	"./ic_stats_big.svg": 707,
	"./ic_synapse.svg": 305,
	"./ic_telegram.svg": 391,
	"./ic_tether_24.svg": 708,
	"./ic_tokens.svg": 709,
	"./ic_totaluser.svg": 392,
	"./ic_trading.svg": 393,
	"./ic_transfer_avax.svg": 710,
	"./ic_twitter.svg": 394,
	"./ic_uni_24.svg": 711,
	"./ic_uni_40.svg": 712,
	"./ic_usdc.e_24.svg": 713,
	"./ic_usdc.e_40.svg": 714,
	"./ic_usdc_24.svg": 715,
	"./ic_usdc_40.svg": 716,
	"./ic_usdt_24.svg": 717,
	"./ic_usdt_40.svg": 718,
	"./ic_wallet_24.svg": 719,
	"./ic_wavax_24.svg": 720,
	"./ic_wavax_40.svg": 721,
	"./ic_wbnb_40.svg": 722,
	"./ic_wbtc_24.svg": 723,
	"./ic_wbtc_40.svg": 724,
	"./ic_weth_24.svg": 725,
	"./ic_weth_40.svg": 726,
	"./lg_arbitrum.svg": 727,
	"./logo-web.png": 448,
	"./logo_GMX.svg": 217,
	"./logo_GMX_small.svg": 728,
	"./logo_oap.svg": 729,
	"./logo_oap_white.svg": 293,
	"./logo_open_white.svg": 395,
	"./long.svg": 396,
	"./metamask-text.svg": 730,
	"./metamask.png": 397,
	"./page-not-found.svg": 731,
	"./position-share-bg.png": 398,
	"./short.svg": 399,
	"./swap.svg": 252,
	"./trading.jpg": 732,
	"./wallet-connect-text.svg": 733,
	"./walletconnect-circle-blue.svg": 400,
	"./wave-01.png": 734,
	"./wave-02.png": 735
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 622;